import { backendHost } from '@/global';
import { ResponseDataType } from '@/types';

export async function fetchData<T>(
  url: string,
  cacheParam: 'no-store' | 'force-cache' = 'no-store',
): Promise<T> {
  const params = { cache: cacheParam };
  const res = await fetch(`${backendHost}${url}`, params);

  const vacancies: ResponseDataType<T> = await res.json();

  return vacancies.data;
}
